import {
  LayoutDashboard,
  Repeat,
  Users,
  MapPin,
  HardDrive,
  Package,
  History,
  MessageSquare,
  FileText,
  ShieldCheck
} from "lucide-react";

const fileManager = [
  {
    name: "Dashboard",
    icon: LayoutDashboard,
    to: "/",
  },
  {
    name: "Subscription",
    icon: Repeat,
    to: "/subscription",
  },
  {
    name: "User",
    icon: Users,
    to: "/users",
  },
  {
    name: "Location",
    icon: MapPin,
    to: "/location",
  },
  {
    name: "Storage",
    icon: HardDrive,
    to: "/storage",
  },
  {
    name: "Products",
    icon: Package,
    to: "/products",
  },
  {
    name: "Activity",
    icon: History,
    to: "/activity",
  },
  {
    name: "Engagement",
    icon: MessageSquare,
    to: "/engagement",
  },
  {
    name: "Content",
    icon: FileText,
    to: "/content",
  },
  {
    name: "Site Control",
    icon: ShieldCheck,
    to: "/site-control",
  },
];

const sharedFile = [];

export { fileManager, sharedFile };
